import { useKillSplineLogo } from '../hooks/useKillSplineLogo';

/**
 * React component that automatically removes Spline logo elements from the DOM
 * 
 * This component uses the useKillSplineLogo hook to:
 * - Remove any existing Spline logo elements on mount
 * - Continuously monitor the DOM for new Spline logo elements
 * - Automatically remove them when they appear
 * 
 * Usage: Add <UseKillSplineLogo /> at the root of your App component
 * 
 * @returns null - This component renders nothing, only performs side effects
 */
const UseKillSplineLogo = () => {
  useKillSplineLogo();
  return null;
};

export default UseKillSplineLogo;
